'use strict';
module.exports = require('./ColumnGroup.vue');